import { render, staticRenderFns } from "./BestBuysConfigPane.vue?vue&type=template&id=81828e22&scoped=true"
import script from "./BestBuysConfigPane.vue?vue&type=script&lang=js"
export * from "./BestBuysConfigPane.vue?vue&type=script&lang=js"
import style0 from "./BestBuysConfigPane.vue?vue&type=style&index=0&id=81828e22&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81828e22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81828e22')) {
      api.createRecord('81828e22', component.options)
    } else {
      api.reload('81828e22', component.options)
    }
    module.hot.accept("./BestBuysConfigPane.vue?vue&type=template&id=81828e22&scoped=true", function () {
      api.rerender('81828e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/best_buys/BestBuysConfigPane.vue"
export default component.exports